export const GlobalScripts = () => {
  return <></>;
};
